import React, { useState } from "react";
import logo from "./assets/logo.svg";
import "./App.css";
import axios, { AxiosError } from "axios";
import { useTimer } from "react-timer-hook";
import moment from "moment";

function App() {
  const api = axios.create({ baseURL: "https://sd.callink.com.br:2087" });

  const [email, setEmail] = useState<string>("");
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();

    try {
      setError(null);
      setResult(null);
      setLoading(true);
      const { data } = await api.post("/generateToken", { email });
      console.log(data);
      setResult(data);
      setEmail("");
    } catch (err: any) {
      const errMsg =
        err?.response && err?.response?.data
          ? err?.response?.data?.err
          : `Houve um erro: ${err.toString()}`;
      setError(errMsg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="App flex flex-col items-center justify-center lg:d-none">
      <div className="flex justify-center items-center">
        <img
          className="mb-4 mr-2"
          width={40}
          height={40}
          src={logo}
          alt="Logotipo"
        ></img>
        <h1 className="text-[#C3FF5C] text-4xl font-bold"> SD Token</h1>
      </div>

      <div className="flex flex-col items-center">
        <p className="text-white lg:text-2xl text-left lg:h-[200px] lg:w-full w-[90%]  flex justify-center items-center mt-5 bg-[#303338] py-4 px-5 lg:font-semibold rounded ">
          Para contato externo com nossa Central de Serviços é necessário a
          geração de um Token de atendimento. <br></br> <br></br> Após a geração
          do Token que será enviado para o seu e-mail corporativo, será
          necessário informar o Token ao analista responsável.
        </p>

        <form onSubmit={handleSubmit} className="w-[90%] lg:w-full">
          <div className="mb-6 mt-10 ">
            <label
              htmlFor="email"
              className="block text-start mb-2 text-lg font-medium text-white"
            >
              Seu e-mail corporativo
            </label>
            <input
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const { value } = event.target;
                setEmail(value);
              }}
              value={email}
              placeholder="Seu e-mail corporativo"
              type="email"
              id="email"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            ></input>
          </div>
          <button
            disabled={!email || loading}
            className="px-5 py-3 hover:bg-slate-700 bg-slate-800 text-white font-bold rounded self-start flex"
          >
            {loading ? "Aguarde..." : "Solicitar"}
          </button>

          {error && (
            <p className="text-2xl mt-5 text-red-500 font-bold px-2 py-2">
              {error}
            </p>
          )}

          {result && (
            <div>
              <p className="lg:font-bold text-[#fbfdff]  bg-[#303338] py-10 rounded shadow-lg drop-shadow-lg text-lg lg:text-3xl mt-4 lg:mt-10">
                Token gerado e enviado ao e-mail informado. Válido por{" "}
                <strong className="text-[#C3FF5C]">{result} minutos</strong>.
              </p>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default App;
